import { TypeAnimation } from "react-type-animation";

const PARSING_MESSAGES = [
  "Reading through the paperwork...",
  "Finding the right place for every file...",
  "Matching documents to company records...",
  "Connecting names, dates, and documents...",
  "Making your records a little smarter...",
  "Almost done...",
];

const LINE_HOLD_MS = 900;

// sequence alternates [text, holdMs, text, holdMs, ...]; TypeAnimation types,
// holds, then deletes each entry and loops forever.
const SEQUENCE = PARSING_MESSAGES.flatMap((message) => [message, LINE_HOLD_MS]);

export const ParsingMessages = () => (
  <TypeAnimation
    sequence={SEQUENCE}
    repeat={Infinity}
    speed={50}
    cursor={false}
    className="t-text-body t-text-neutral-40 t-select-none"
  />
);
